module.exports = __webpack_public_path__ + "static/media/boat-img-1.b1b42a41.jpg";